var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "resellers-reports", tag: "section" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary" },
                  on: { click: _vm.exportData }
                },
                [_c("v-icon", [_vm._v("mdi-download")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        staticClass: "searchBox",
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: _vm.$t("global.search"),
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c("v-spacer"),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.months,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Select a period",
                          "return-object": "",
                          autocomplete: "off"
                        },
                        on: {
                          change: function($event) {
                            return _vm.selectMonth(_vm.period)
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "append-item",
                            fn: function() {
                              return [
                                _c("div", {
                                  directives: [
                                    {
                                      name: "intersect",
                                      rawName: "v-intersect",
                                      value: _vm.onIntersect,
                                      expression: "onIntersect"
                                    }
                                  ],
                                  staticClass: "pa-4 teal--text"
                                })
                              ]
                            },
                            proxy: true
                          }
                        ]),
                        model: {
                          value: _vm.period,
                          callback: function($$v) {
                            _vm.period = $$v
                          },
                          expression: "period"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              filterable: "",
              headers: _vm.computedHeaders.map(function(x) {
                return Object.assign({}, x, { text: _vm.$t(x.text) })
              }),
              items: _vm.items,
              "item-key": "id",
              loading: _vm.loading,
              search: _vm.search,
              "items-per-page": _vm.rowsPerPage
            },
            scopedSlots: _vm._u([
              {
                key: "item.reseller",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.resellerName) + " ")]
                }
              },
              {
                key: "item.totalSessions",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.totalSessions) + " ")]
                }
              },
              {
                key: "item.monthlySessions",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.monthlySessions) + " ")]
                }
              },
              {
                key: "item.activityChange",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-chip",
                      {
                        attrs: {
                          color: _vm.activityChangeColor(item.activityChange)
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(item.activityChange > 0 ? "+" : "") +
                            _vm._s(item.activityChange) +
                            " "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.standardAccounts",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.standardAccounts) + " ")]
                }
              },
              {
                key: "item.trialAccounts",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.trialAccounts) + " ")]
                }
              },
              {
                key: "item.numberOfAdmins",
                fn: function(ref) {
                  var item = ref.item
                  return [_vm._v(" " + _vm._s(item.numberOfAdmins) + " ")]
                }
              },
              {
                key: "item.expiryDate",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("span", { class: _vm.textColor(item.expiryDate) }, [
                      _vm._v(" " + _vm._s(_vm.displayTime(item.expiryDate)))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.userRoleIs("developer")
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Report Management")]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    { staticClass: "red--text" },
                    [
                      _c("date-range-picker", {
                        attrs: { "text-color": _vm.datePickerColor },
                        on: { datesChange: _vm.reportDatesChanged }
                      }),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue",
                            disabled: _vm.query.processingReport
                          },
                          on: { click: _vm.generateNewReport }
                        },
                        [_vm._v(" Create ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            disabled: _vm.query.processingReport
                          },
                          on: { click: _vm.deleteReport }
                        },
                        [_vm._v(" Delete ")]
                      ),
                      _c("p", [
                        _c("span", { attrs: { color: "red" } }, [
                          _vm._v(" " + _vm._s(_vm.error) + " ")
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }